import type { LucideProps } from "lucide-react"
import type { ComponentType, ReactNode } from "react"

import { Rivets } from "@/components/rivets"
import { cn } from "@/lib/utils"

interface EmptyStateProps {
  icon: ComponentType<LucideProps>
  title: string
  description?: string
  action?: ReactNode
  className?: string
  shieldIcon?: boolean
}

export function EmptyState({
  icon: IconComponent,
  title,
  description,
  action,
  className,
  shieldIcon = false,
}: EmptyStateProps) {
  return (
    <div
      data-slot="empty-state"
      className={cn(
        "relative flex flex-col items-center justify-center border-none bg-[oklch(0.2_0.008_240)] px-6 py-16 text-center shadow-[0_2px_8px_oklch(0_0_0/0.6)]",
        className,
      )}
    >
      <Rivets />
      {shieldIcon ? (
        <div
          className="mb-5 flex items-center justify-center [clip-path:polygon(8%_0%,92%_0%,100%_8%,100%_85%,50%_100%,0%_85%,0%_8%)]"
          style={{
            width: 64,
            height: 80,
            background:
              "linear-gradient(180deg, oklch(0.30 0.05 55), oklch(0.18 0.02 55))",
            border: "2px solid var(--border-heavy)",
          }}
        >
          <IconComponent
            className="size-8"
            style={{ color: "var(--accent)" }}
          />
        </div>
      ) : (
        <IconComponent className="text-muted-foreground mb-4 size-10" />
      )}
      <p
        className="font-display text-3xl leading-none font-bold"
        style={{
          color: "var(--accent)",
          textShadow:
            "0 0 6px oklch(0.8 0.16 85 / 0.3), 0 0 16px oklch(0.7 0.14 85 / 0.12), 0 0 24px oklch(0.8 0.3 145 / 0.2), 0 1px 0 oklch(0.55 0.1 85), 0 2px 4px oklch(0 0 0 / 0.5)",
        }}
      >
        {title}
      </p>
      {description && (
        <p className="text-muted-foreground mt-3 max-w-sm text-sm">
          {description}
        </p>
      )}
      {action && <div className="mt-6">{action}</div>}
    </div>
  )
}
